module.exports = __webpack_public_path__ + "img/latvia.eeaa9a6d.svg";